import { useEffect } from 'react'
import { createGlobalStyle } from 'styled-components'
import NProgress from 'nprogress'

const NProgressStyle = createGlobalStyle`
  /* Make clicks pass-through */
  #nprogress {
    pointer-events: none;
  }

  #nprogress .bar {
    background: ${({ theme }) => theme.brand.jungle};

    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;

    width: 100%;
    height: 2px;
  }

  .nprogress-custom-parent {
    position: relative;
  }

  .nprogress-custom-parent #nprogress .bar {
    position: absolute;
  }
`

const GlobalLoader = ({ loading }) => {
  useEffect(() => {
    NProgress.configure({
      parent: '.js-global-loader-container',
      showSpinner: false,
      speed: 300,
    })
    if (loading) {
      NProgress.start()
    } else {
      NProgress.done()
    }
  }, [loading])

  return <NProgressStyle />
}

export default GlobalLoader
